import React from "react";
import { useContent } from "../context/ContentContext";

const sizes = { sm: "h-10", md: "h-14 md:h-16", lg: "h-20" };

const Logo = ({ size = "md", light = false, className = "" }) => {
  const { settings } = useContent();
  return (
    <img
      src={settings.logo || "/logo.png"}
      alt="Fly Jannah Tours & Travels"
      data-testid="site-logo"
      className={`${sizes[size]} w-auto object-contain ${light ? "bg-white rounded-lg px-2 py-1" : ""} ${className}`}
    />
  );
};

export default Logo;
